import Amplify, {Logger} from 'aws-amplify';

import { JwtHelper } from 'pac-platform-ui-auth';
const helper = new JwtHelper();

let decodedToken = helper.run();
let config = window['AppConfig'];

const logger = new Logger('amplify_config');

// switch (process.env.NODE_ENV) {
//   case 'development':
//     Amplify.Logger.LOG_LEVEL = 'INFO';
//     break;
//   case 'production':
//     Amplify.Logger.LOG_LEVEL = 'INFO';
//     break;
//   default:
//     break;
// }

if (typeof decodedToken !== 'undefined') {

  logger.debug("JWT: ", decodedToken);

  if (decodedToken.pac_user_pool_id && decodedToken.pac_app_client_id) {
    config.Auth.userPoolId = decodedToken.pac_user_pool_id;
    config.Auth.userPoolWebClientId = decodedToken.pac_app_client_id;
  }
  if (decodedToken.pac_user_pool_domain) {
    config.Auth.oauth = {
      
      domain: decodedToken.pac_user_pool_domain + '.auth.us-west-2.amazoncognito.com',
      scope: ['email', 'openid'],
      redirectSignIn: window.location.href.split('#')[0],
      redirectSignOut: "https://login.nextcloud.aero",

      // 'code' for Authorization code grant, 
      // 'token' for Implicit grant
      responseType: 'token',
    };
  }
}

logger.debug("AMPLIFY CONFIG: ",config);

export default config;
